import * as angular from "angular";
import {IController} from "angular";

export class vehiclesTableCtrl implements IController {

  vehicles: any;
  defaultVehicleSelectedId: string;
  onEdit: Function;
  onClick: Function;
  onDefault: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehiclesTable', {
    bindings: {
      vehicles: '<',
      defaultVehicleSelectedId: '<',
      onEdit: '&',
      onClick: '&',
      onDefault: '&?'
    },
    template: require('./vehicles-table.html').default,
    controller: vehiclesTableCtrl
  });
